import { render, staticRenderFns } from "./consignorAccount.vue?vue&type=template&id=728ab9be&scoped=true&"
import script from "./consignorAccount.vue?vue&type=script&lang=js&"
export * from "./consignorAccount.vue?vue&type=script&lang=js&"
import style0 from "./consignorAccount.vue?vue&type=style&index=0&id=728ab9be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ab9be",
  null
  
)

export default component.exports